import { Flex } from "antd";
import { styled } from "styled-components";
import { MenuOutlined } from '@ant-design/icons';

export const NavbarContainer = styled.nav`
    position: fixed;
    width: 100%;
    z-index: 50;
    height: 60px;
    backdrop-filter: blur(5px);
    background-color: rgba(0, 0, 0, 0.5);
    top: 0
`;

export const NavigationContent = styled(Flex)`
    width: 50%;

    @media (max-width: 820px) {
        display: none;
    }
`;

export const Hamburger = styled(MenuOutlined)`
    display: none;
    color: white;
    
    @media (max-width: 820px) {
        display: flex;
        align-items: center;
    }
`;